export default __webpack_public_path__ + "static/media/shutdown.fddf00a6.mp3";